module.exports = __webpack_public_path__ + "static/img/travel.c4b162e2.svg";